enum EventType {
    LOAD = 'load',
    BUFFER = 'buffer',
    PLAY = 'play',
    PAUSE = 'pause',
    END = 'end',
    ERROR = 'error',
    TIMEUPDATE = 'timeupdate'
}

export default EventType;